import api from "../config/api";

export const getTasks = async (data) => {
  const res = await api.get("tasks", data);
  return res.data;
};

export const getTaskByid = async (_id) => {
  const res = await api.get(`tasks/${_id}`);
  return res.data;
};

export const getTasksCalender = async (data) => {
  const res = await api.get("tasks/calendar", data);
  return res.data;
};
